var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.albumsSortedByMonth),function(albumGroup,index){return _c('div',{key:index},[_c('album-date-group',{attrs:{"albums":albumGroup,"showDateGroup":_vm.showDateGroup(index)}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }